import {useAccessToken} from "../../services/auth"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {approveIncomingWire, IncomingWire, WireCounterparty} from "../../resources/incomingWire"
import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import {CounterpartyAccountType, CounterpartyAccountTypeEnum} from "../../resources/counterparty"

interface ApproveIncomingWireModalProps {
	incomingWire: IncomingWire
	close: () => void
	onSuccess: () => void
}
function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function ApproveIncomingWireMissingDetails({incomingWire, close, onSuccess}: ApproveIncomingWireModalProps) {
	const accessToken = useAccessToken()

	const currAccountId = incomingWire.relationships.account?.data.id
	const counterparty = incomingWire.attributes.counterparty
	const noDetailsMissing = !!(currAccountId && counterparty)

	const [state, approve] = useAsyncResultIdle(approveIncomingWire)
	const [accountId, setAccountId] = useState<string>("")

	const [counterpartyName, setCounterPartyName] = useState<string>("")
	const [counterpartyRoutingNumber, setCounterPartyRoutingNumber] = useState<string>("")
	const [counterpartyAccountNumber, setCounterPartyAccountNumber] = useState<string>("")
	const [counterpartyAccountType, setCounterPartyAccountType] = useState<string>("")

	const updatedAccountId = !currAccountId ? accountId : undefined
	const updatedWireCounterparty = !counterparty
		? ({
				name: counterpartyName,
				accountNumber: counterpartyAccountNumber,
				routingNumber: counterpartyRoutingNumber,
				accountType: counterpartyAccountType,
		  } as WireCounterparty)
		: undefined

	return (
		<AsyncResultModal
			title="Approve Incoming Wire"
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-success"
			state={state}
			buttonText="Approve"
			successText="Approved"
			onSubmit={() => {
				approve(accessToken, incomingWire.id, Number(updatedAccountId), updatedWireCounterparty)
			}}
			errorToText={(err) => err.errors[0].title}
		>
			{!currAccountId && (
				<div className="field">
					<label className="label">Account Id</label>
					<div className="control">
						<input
							className="input"
							type="text"
							pattern="^[0-9]*$"
							value={accountId}
							onChange={(e) => setAccountId(e.target.value)}
						/>
					</div>
				</div>
			)}
			{!counterparty && (
				<>
					<div className="field">
						<label className="label">Counterparty Name</label>
						<div className="control">
							<input
								required
								className="input"
								type="text"
								pattern="^[a-zA-Z0-9\s]*$"
								value={counterpartyName}
								onChange={(e) => setCounterPartyName(e.target.value)}
							/>
						</div>
					</div>
					<div className="field">
						<label className="label">Counterparty Routing Number</label>
						<div className="control">
							<input
								required
								className="input"
								type="text"
								pattern="^[0-9]*$"
								value={counterpartyRoutingNumber}
								onChange={(e) => setCounterPartyRoutingNumber(e.target.value)}
							/>
						</div>
					</div>
					<div className="field">
						<label className="label">Counterparty Account Number</label>
						<div className="control">
							<input
								required
								className="input"
								type="text"
								pattern="^[0-9]*$"
								value={counterpartyAccountNumber}
								onChange={(e) => setCounterPartyAccountNumber(e.target.value)}
							/>
						</div>
					</div>
					<div className="field">
						<label className="label">Counterparty Account Type</label>
						<div className="control">
							<div className="select">
								<select
									required
									value={counterpartyAccountType}
									onChange={(e) => setCounterPartyAccountType(e.target.value as CounterpartyAccountType)}
								>
									<option key="empty" value=""></option>
									{Object.values(CounterpartyAccountTypeEnum).map((accountTypeOption) => (
										<option key={accountTypeOption} value={accountTypeOption}>
											{accountTypeOption}
										</option>
									))}
								</select>
							</div>
						</div>
					</div>
				</>
			)}
			{noDetailsMissing && "Are you sure?"}
		</AsyncResultModal>
	)
}
